// https://docs.fineuploader.com/tag/3.8.2/features/handling-errors.html
export default {
    'it-IT': {
        'de-DE': {
            speakLang: 'Sprechen Sie Deutsch?',
            buyOn: 'Kaufen Sie jetzt auf www.inwild.de',
            ok: 'OK, ich möchte auf die Seite weitergeleitet werden',
            cancel: 'Nein, danke',
        },
        'en-AU': {
            speakLang: 'Do you speak English?',
            buyOn: 'Buy now on www.inwild.com',
            ok: 'OK, Go to site',
            cancel: 'No, thanks',
        },
        'en-GB': {
            speakLang: 'Do you speak English?',
            buyOn: 'Buy now on www.inwild.co.uk',
            ok: 'OK, Go to site',
            cancel: 'No, thanks',
        },
        'en-US': {
            speakLang: 'Do you speak English?',
            buyOn: 'Buy now on www.inwild.com',
            ok: 'OK, Go to site',
            cancel: 'No, thanks',
        },
        'es-ES': {
            speakLang: '¿Hablas español?',
            buyOn: 'Compra ahora en www.inwild.es',
            ok: 'OK, ir al sitio',
            cancel: 'No, gracias',
        },
        'fr-FR': {
            speakLang: 'Vous parlez français?',
            buyOn: 'Achetez maintenant sur www.inwild.fr',
            ok: 'Oui, me rediriger sur le site',
            cancel: 'Non, merci',
        },
    },
    'fr-FR': {
        'de-DE': {
            speakLang: 'Sprechen Sie Deutsch?',
            buyOn: 'Kaufen Sie jetzt auf www.inwild.de',
            ok: 'OK, ich möchte auf die Seite weitergeleitet werden',
            cancel: 'Nein, danke',
        },
        'en-AU': {
            speakLang: 'Do you speak English?',
            buyOn: 'Buy now on www.inwild.com',
            ok: 'OK, Go to site',
            cancel: 'No, thanks',
        },
        'en-GB': {
            speakLang: 'Do you speak English?',
            buyOn: 'Buy now on www.inwild.co.uk',
            ok: 'OK, Go to site',
            cancel: 'No, thanks',
        },
        'en-US': {
            speakLang: 'Do you speak English?',
            buyOn: 'Buy now on www.inwild.com',
            ok: 'OK, Go to site',
            cancel: 'No, thanks',
        },
        'es-ES': {
            speakLang: '¿Hablas español?',
            buyOn: 'Compra ahora en www.inwild.es',
            ok: 'OK, ir al sitio',
            cancel: 'No, gracias',
        },
        'it-IT': {
            speakLang: 'Parli italiano?',
            buyOn: 'Acquista ora su www.inwild.it',
            ok: 'OK, Portami al sito',
            cancel: 'No, grazie',
        },
    },
    'es-ES': {
        'de-DE': {
            speakLang: 'Sprechen Sie Deutsch?',
            buyOn: 'Kaufen Sie jetzt auf www.inwild.de',
            ok: 'OK, ich möchte auf die Seite weitergeleitet werden',
            cancel: 'Nein, danke',
        },
        'en-AU': {
            speakLang: 'Do you speak English?',
            buyOn: 'Buy now on www.inwild.com',
            ok: 'OK, Go to site',
            cancel: 'No, thanks',
        },
        'en-GB': {
            speakLang: 'Do you speak English?',
            buyOn: 'Buy now on www.inwild.co.uk',
            ok: 'OK, Go to site',
            cancel: 'No, thanks',
        },
        'en-US': {
            speakLang: 'Do you speak English?',
            buyOn: 'Buy now on www.inwild.com',
            ok: 'OK, Go to site',
            cancel: 'No, thanks',
        },
        'fr-FR': {
            speakLang: 'Vous parlez français?',
            buyOn: 'Achetez maintenant sur www.inwild.fr',
            ok: 'Oui, me rediriger sur le site',
            cancel: 'Non, merci',
        },
        'it-IT': {
            speakLang: 'Parli italiano?',
            buyOn: 'Acquista ora su www.inwild.it',
            ok: 'OK, Portami al sito',
            cancel: 'No, grazie',
        },
    },
    'en-GB': {
        'de-DE': {
            speakLang: 'Sprechen Sie Deutsch?',
            buyOn: 'Kaufen Sie jetzt auf www.inwild.de',
            ok: 'OK, ich möchte auf die Seite weitergeleitet werden',
            cancel: 'Nein, danke',
        },
        'en-AU': {
            speakLang: 'Do you speak English?',
            buyOn: 'Buy now on www.inwild.com',
            ok: 'OK, Go to site',
            cancel: 'No, thanks',
        },
        'en-US': {
            speakLang: 'Do you speak English?',
            buyOn: 'Buy now on www.inwild.com',
            ok: 'OK, Go to site',
            cancel: 'No, thanks',
        },
        'es-ES': {
            speakLang: '¿Hablas español?',
            buyOn: 'Compra ahora en www.inwild.es',
            ok: 'OK, ir al sitio',
            cancel: 'No, gracias',
        },
        'fr-FR': {
            speakLang: 'Vous parlez français?',
            buyOn: 'Achetez maintenant sur www.inwild.fr',
            ok: 'Oui, me rediriger sur le site',
            cancel: 'Non, merci',
        },
        'it-IT': {
            speakLang: 'Parli italiano?',
            buyOn: 'Acquista ora su www.inwild.it',
            ok: 'OK, Portami al sito',
            cancel: 'No, grazie',
        },
    },
    'en-US': {
        'de-DE': {
            speakLang: 'Sprechen Sie Deutsch?',
            buyOn: 'Kaufen Sie jetzt auf www.inwild.de',
            ok: 'OK, ich möchte auf die Seite weitergeleitet werden',
            cancel: 'Nein, danke',
        },
        'en-AU': {
            speakLang: 'Do you speak English?',
            buyOn: 'Buy now on www.inwild.com',
            ok: 'OK, Go to site',
            cancel: 'No, thanks',
        },
        'en-GB': {
            speakLang: 'Do you speak English?',
            buyOn: 'Buy now on www.inwild.co.uk',
            ok: 'OK, Go to site',
            cancel: 'No, thanks',
        },
        'es-ES': {
            speakLang: '¿Hablas español?',
            buyOn: 'Compra ahora en www.inwild.es',
            ok: 'OK, ir al sitio',
            cancel: 'No, gracias',
        },
        'fr-FR': {
            speakLang: 'Vous parlez français?',
            buyOn: 'Achetez maintenant sur www.inwild.fr',
            ok: 'Oui, me rediriger sur le site',
            cancel: 'Non, merci',
        },
        'it-IT': {
            speakLang: 'Parli italiano?',
            buyOn: 'Acquista ora su www.inwild.it',
            ok: 'OK, Portami al sito',
            cancel: 'No, grazie',
        },
    },
    'de-DE': {
        'en-AU': {
            speakLang: 'Do you speak English?',
            buyOn: 'Buy now on www.inwild.com',
            ok: 'OK, Go to site',
            cancel: 'No, thanks',
        },
        'en-GB': {
            speakLang: 'Do you speak English?',
            buyOn: 'Buy now on www.inwild.co.uk',
            ok: 'OK, Go to site',
            cancel: 'No, thanks',
        },
        'en-US': {
            speakLang: 'Do you speak English?',
            buyOn: 'Buy now on www.inwild.com',
            ok: 'OK, Go to site',
            cancel: 'No, thanks',
        },
        'es-ES': {
            speakLang: '¿Hablas español?',
            buyOn: 'Compra ahora en www.inwild.es',
            ok: 'OK, ir al sitio',
            cancel: 'No, gracias',
        },
        'fr-FR': {
            speakLang: 'Vous parlez français?',
            buyOn: 'Achetez maintenant sur www.inwild.fr',
            ok: 'Oui, me rediriger sur le site',
            cancel: 'Non, merci',
        },
        'it-IT': {
            speakLang: 'Parli italiano?',
            buyOn: 'Acquista ora su www.inwild.it',
            ok: 'OK, Portami al sito',
            cancel: 'No, grazie',
        },
    },
    'en-AU': {
        'de-DE': {
            speakLang: 'Sprechen Sie Deutsch?',
            buyOn: 'Kaufen Sie jetzt auf www.inwild.de',
            ok: 'OK, ich möchte auf die Seite weitergeleitet werden',
            cancel: 'Nein, danke',
        },
        'en-GB': {
            speakLang: 'Do you speak English?',
            buyOn: 'Buy now on www.inwild.co.uk',
            ok: 'OK, Go to site',
            cancel: 'No, thanks',
        },
        'en-US': {
            speakLang: 'Do you speak English?',
            buyOn: 'Buy now on www.inwild.com',
            ok: 'OK, Go to site',
            cancel: 'No, thanks',
        },
        'es-ES': {
            speakLang: '¿Hablas español?',
            buyOn: 'Compra ahora en www.inwild.es',
            ok: 'OK, ir al sitio',
            cancel: 'No, gracias',
        },
        'fr-FR': {
            speakLang: 'Vous parlez français?',
            buyOn: 'Achetez maintenant sur www.inwild.fr',
            ok: 'Oui, me rediriger sur le site',
            cancel: 'Non, merci',
        },
        'it-IT': {
            speakLang: 'Parli italiano?',
            buyOn: 'Acquista ora su www.inwild.it',
            ok: 'OK, Portami al sito',
            cancel: 'No, grazie',
        },
    },
};
